"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availableBitrateHelper = void 0;
const video_client_core_1 = require("@video/video-client-core");
/**
 * Returns pretty-printed bitrate.
 */
function _formatBitrate(quality, defaultVal = "") {
    var _a;
    if (quality.layer == null) {
        return defaultVal;
    }
    return (((_a = quality.layer.bitrate) !== null && _a !== void 0 ? _a : 0) / 1000).toFixed(2);
}
function _getUIBitrateLevel(availableQualities, preferenceArray, name) {
    let preferredLevel = null;
    let formattedBitrate = null;
    for (const item of preferenceArray) {
        const foundQuality = availableQualities.find((q) => q.level === item);
        if (foundQuality != null) {
            preferredLevel = item;
            formattedBitrate = _formatBitrate(foundQuality);
            break;
        }
    }
    return { score: preferredLevel, name, formattedBitrate };
}
const availableBitrateHelper = (availableQualities) => {
    if (availableQualities == null) {
        return [];
    }
    const auto = _getUIBitrateLevel(availableQualities, [video_client_core_1.AutoQualityLevel.Auto], "Auto");
    const source = _getUIBitrateLevel(availableQualities, [video_client_core_1.SourceScoreLevel.Low, video_client_core_1.SourceScoreLevel.Medium, video_client_core_1.SourceScoreLevel.High], "Source");
    const low = _getUIBitrateLevel(availableQualities, [video_client_core_1.TranscodeScoreLevel.Low, video_client_core_1.TranscodeScoreLevel.Lowest], "Low");
    const medium = _getUIBitrateLevel(availableQualities, [video_client_core_1.TranscodeScoreLevel.Medium, video_client_core_1.TranscodeScoreLevel.MediumHigh, video_client_core_1.TranscodeScoreLevel.MediumLow], "Medium");
    const high = _getUIBitrateLevel(availableQualities, [video_client_core_1.TranscodeScoreLevel.High, video_client_core_1.TranscodeScoreLevel.Highest], "High");
    return [auto, source, low, medium, high].filter((qty) => qty.score != null);
};
exports.availableBitrateHelper = availableBitrateHelper;
//# sourceMappingURL=utils.js.map